import React, { useState } from "react";
import "./SucursalesData.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SucursalesData() {
  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");
  const [telefono, setTelefono] = useState("");

  const guardar = () => {
    // aquí iría tu fetch al backend
    toast.success("Sucursal guardada (ejemplo)");
  };

  
}
